const DB_NAME = 'duckpilot';
const STORE_NAME = 'datasets';
const DB_VERSION = 1;

const isSupported = () => typeof indexedDB !== 'undefined';

const openDatabase = () => new Promise((resolve, reject) => {
  if (!isSupported()) {
    reject(new Error('IndexedDB is not available'));
    return;
  }

  const request = indexedDB.open(DB_NAME, DB_VERSION);

  request.onupgradeneeded = () => {
    const db = request.result;
    if (!db.objectStoreNames.contains(STORE_NAME)) {
      db.createObjectStore(STORE_NAME, { keyPath: 'file_id' });
    }
  };

  request.onsuccess = () => resolve(request.result);
  request.onerror = () => reject(request.error);
});

const saveDataset = async (record) => {
  if (!isSupported()) return;
  const db = await openDatabase();
  await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error || new Error('Failed to save dataset'));
    tx.objectStore(STORE_NAME).put(record);
  });
};

const loadAllDatasets = async () => {
  if (!isSupported()) return [];
  const db = await openDatabase();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readonly');
    const request = tx.objectStore(STORE_NAME).getAll();
    request.onsuccess = () => resolve(request.result || []);
    request.onerror = () => reject(request.error || new Error('Failed to load datasets'));
  });
};

const loadDatasetById = async (fileId) => {
  if (!isSupported()) return null;
  const db = await openDatabase();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readonly');
    const request = tx.objectStore(STORE_NAME).get(fileId);
    request.onsuccess = () => resolve(request.result || null);
    request.onerror = () => reject(request.error || new Error('Failed to load dataset'));
  });
};

const deleteDataset = async (fileId) => {
  if (!isSupported()) return;
  const db = await openDatabase();
  await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error || new Error('Failed to delete dataset'));
    tx.objectStore(STORE_NAME).delete(fileId);
  });
};

const clearAll = async () => {
  if (!isSupported()) return;
  const db = await openDatabase();
  await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error || new Error('Failed to clear datasets'));
    tx.objectStore(STORE_NAME).clear();
  });
};

const datasetStorage = {
  isSupported,
  saveDataset,
  loadAllDatasets,
  loadDatasetById,
  deleteDataset,
  clearAll
};

export default datasetStorage;
